"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ciPortalApiFactory = void 0;
const project_api_1 = require("./domains/project/project.api");
const connector_1 = require("./connector");
const project_status_api_1 = require("./domains/project-status/project-status.api");
const project_forecast_type_api_1 = require("./domains/project-forecast-type/project-forecast-type.api");
const project_forecast_api_1 = require("./domains/project-forecast/project-forecast.api");
const project_invoice_api_1 = require("./domains/project-invoice/project-invoice.api");
const project_order_api_1 = require("./domains/project-order/project-order.api");
const company_api_1 = require("./domains/company/company.api");
const ci_portal_api_1 = require("./ci-portal-api");
const project_tracking_api_1 = require("./domains/project-tracking/project-tracking.api");
const auth_manager_1 = require("../auth/auth-manager");
const auth_event_emitter_1 = require("../auth/auth-event-emitter");
const ci_portal_api_config_1 = require("../utils/ci-portal-api-config");
/**
 * @description
 * Create a Ci Portal API
 *
 * @param options
 */
function ciPortalApiFactory(options) {
    var _a, _b, _c, _d;
    const verifyResponses = (_a = options.verifyResponses) !== null && _a !== void 0 ? _a : false;
    const verbose = (_b = options.verbose) !== null && _b !== void 0 ? _b : false;
    const logger = (_d = (_c = options.logger) !== null && _c !== void 0 ? _c : (console)) !== null && _d !== void 0 ? _d : undefined;
    const baseApiUrl = options.baseApiUrl.endsWith('/')
        ? options.baseApiUrl.substr(0, options.baseApiUrl.length - 1)
        : options.baseApiUrl;
    const config = new ci_portal_api_config_1.CiPortalApiConfig(baseApiUrl, options.apiVersion, options.authRefreshWindow);
    const authEventEmitter = new auth_event_emitter_1.AuthEventEmitter();
    // Do not check if Auth Manager by using instanceof CiPortalAuthManager in case there are version
    // incompatibilities between the consumers dependencies and this packages dependencies
    // and their versions of CiPortalAuthManagers are not the same
    const authManager = new auth_manager_1.AuthManager({
        config: config,
        client: options.client,
        loginDetails: options.login,
        authToken: options.authToken,
        retryOptions: options.retry,
        verbose,
        logger,
    }, authEventEmitter);
    const connector = new connector_1.Connector(config, authManager, verbose);
    const company = new company_api_1.CompanyApi(connector, verifyResponses);
    const project = new project_api_1.ProjectApi(connector, verifyResponses);
    const projectTracking = new project_tracking_api_1.ProjectTrackingApi(connector, verifyResponses);
    const projectStatus = new project_status_api_1.ProjectStatusApi(connector, verifyResponses);
    const projectInvoice = new project_invoice_api_1.ProjectInvoiceApi(connector, verifyResponses);
    const projectForecast = new project_forecast_api_1.ProjectForecastApi(connector, verifyResponses);
    const projectForecastType = new project_forecast_type_api_1.ProjectForecastTypeApi(connector, verifyResponses);
    const projectOrder = new project_order_api_1.ProjectOrderApi(connector, verifyResponses);
    const api = new ci_portal_api_1.CiPortalApi(verbose, connector, company, project, projectTracking, projectStatus, projectInvoice, projectForecast, projectForecastType, projectOrder, authEventEmitter);
    return api;
}
exports.ciPortalApiFactory = ciPortalApiFactory;
